import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { IKImage } from 'imagekitio-react';

const Img = ({ src, alt = 'image', height, width, className, ...props }) => {
  const urlEndpoint = 'https://ik.imagekit.io/gupshup/revamp/common-login/';
  return typeof window !== 'undefined' ? (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={src}
      loading="lazy"
      height={height}
      width={width}
      lqip={{ active: true }}
      className={className}
      alt={alt}
      {...props}
    />
  ) : (
    <img
      src={urlEndpoint + 'tr:q-20,bl-6' + src}
      height={height}
      loading="lazy"
      width={width}
      className={className}
      alt={alt}
      {...props}
    />
  );
};

Img.propTypes = {
  // The source path of your image
  src: PropTypes.string.isRequired,
  // The alt tag for SEO
  alt: PropTypes.string.isRequired,
  // Any height restriction.
  height: PropTypes.string,
  // Any width restriction.
  width: PropTypes.string,
  // Any classes you need to add.
  className: PropTypes.string
};

Img.defaultProps = {
  height: null,
  width: null,
  className: null
};

export default memo(Img);
